import { FaWhatsapp } from "react-icons/fa";

function Footer() {
    return (
        <footer className="footer">
            <div className="container footer-grid">
            <div>
                <div className="footer-brand">
                    <img src="/logo-conts-branco.png" className="logo" alt="Conts Contabilidade"/>
                </div>
                <p className="footer-text">Serviços contábeis completos, desde a escrituração até a elaboração de demonstrações financeiras.</p>
            </div>

            <div className="footer-links">
                <strong>Menu</strong>
                <a href="#top">Início</a>
                <a href="#services">Especialidades</a>
                <a href="#about">Sobre</a>
                <a href="#testimonials">Depoimentos</a>
                <a href="#contact">Contato</a>
            </div>

            <div className="footer-links">
                <strong>Contato</strong>
                <a href="https://wa.me/5519995277000" target="_blank" rel="noopener"><FaWhatsapp className="topbar-icon" /></a>
                <p className="footer-text">Av. Independência, 1840 - Head Tower Sala 1103, Alemães, Piracicaba - SP, 13419-155</p>
            </div>
            </div>

            <div className="footer-bottom">
            <div className="container">
                <span>© <span id="currentYear"></span> Conts Contabilidade. Todos os direitos reservados.</span>
            </div>
            </div>
        </footer>
    );
}

export default Footer;